export default {
  API_V3_URL: String(window.location.hostname == 'localhost' && 0 ? '' : 'https://api.progettieducativi.it/api/v3/'),

  SCHOOLS_API_ENDPOINT: String(window.location.hostname == 'localhost' && 0 ? '' : 'https://v2.api.progettieducativi.it/api/v2/schools'),
  LOCATIONS_API_URL: String(window.location.hostname == 'localhost' && 0 ? 'http://localhost:5555/api/v1/' : 'https://locations-api.dev.progettieducativi.it/api/v1/'),
  LOCATIONS_API_ACCESS_TOKEN: 'LOC_BN78FGHiH839X'
};